import React from 'react';
import { SaveNewPasswordForm } from '../common/forms/SaveNewPasswordForm';
import { SubmitButton } from '../common/forms/SubmitButton';

export const ForgotPasswordPage = () => {
  return (
    <main className="flex aic jcc login">
      <div className="panel w500">
        <div className="panel-header small-header flex jcsb">
          <h3 className="f-2">Enter new password</h3>
        </div>
        <div className="panel-body">
          <SaveNewPasswordForm />
        </div>
        <div className="panel-footer no-border flex jcr">
          <SubmitButton apiKey="saveNewPassword" formName="saveNewPassword-form" text="Confirm" />
        </div>
      </div>
    </main>
  );
};
